module.exports = __webpack_public_path__ + "media/images/footer/ministere-hover-04c6abb5a22a072f061c033896148fa2.png";